import { render, staticRenderFns } from "./LineItem.vue?vue&type=template&id=48eb95f6&scoped=true&lang=pug"
import script from "./LineItem.vue?vue&type=script&lang=js"
export * from "./LineItem.vue?vue&type=script&lang=js"
import style0 from "./LineItem.vue?vue&type=style&index=0&id=48eb95f6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb95f6",
  null
  
)

export default component.exports